import { track } from '@ha/analytics';

export const setRemarketingTag = (
  tags,
  { nonInteraction } = { nonInteraction: 1 },
) => {
  track('User tagged for remarketing', { ...tags, nonInteraction });
};
